import React from 'react'
import { Link } from 'gatsby'
import Parameters from './Parameters'
import Responses from './Responses'
import * as apiUtils from '../../../lib/api-utils'
import getCodePieces from '../../../../static/jscript/fortmatHtml'
import { CopyButton } from '../CopyButton/CopyButton'
import { copyToClipboard } from '../../../utils'
import { CopyPasteIcon, SuccessCheckIcon } from '../../icons'

export default function Operations({ operations }) {
  let publicSDKSamples = null
  let publicSDKBlock = null

  const [isCopied, setIsCopied] = React.useState(false)

  const handleCopyClipboard = (code) => {
    copyToClipboard(code)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 3000)
  }

  if (!operations || operations.length === 0) {
    return null
  }

  if (
    operations.x_publicSDKSamples &&
    operations.x_publicSDKSamples.length > 0
  ) {
    publicSDKSamples = operations.x_publicSDKSamples.map(
      (x_publicSDKSample, index) => {
        return (
          <li key={index}>
            <Link
              to={x_publicSDKSample.link}
              className="dx-no-eel"
              target="_blank"
              rel="noopener noreferrer"
            >
              {x_publicSDKSample.language}
            </Link>
          </li>
        )
      },
    )
    publicSDKSamples = <ul>{publicSDKSamples}</ul>
  }

  if (publicSDKSamples) {
    publicSDKBlock = (
      <div className="dax-operation-sdks">
        <span>SDK samples:</span>
        {publicSDKSamples}
      </div>
    )
  }
  return (
    <>
      {operations.map((operation, index) => {
        let opAnchor = `${operation.name}_${operation.anchor}`
        let opAnchorHash = `#${opAnchor}`
        let parsedOperationDescription = ``

        if (operation.description) {
          parsedOperationDescription = apiUtils.parseMarkdown(
            operation.description,
          )
        }

        return (
          <div className="dax-operation" id={opAnchor} key={index}>
            <div className="example-block dax-sample-request">
              <header className="dax-topic-operation">
                <h3 className="dx-anchor">
                  <Link
                    className="dx-anchor__icon"
                    to={opAnchorHash}
                    aria-hidden="true"
                  />
                  {operation.summary}
                </h3>

                <div className="dax-operation-verbpath">
                  <span
                    className={`dax-operation-verb dax-operation-verb-${operation.method}`}
                  >
                    {operation.method.toUpperCase()}
                  </span>
                  <span className="dax-operation-path">{operation.path}</span>
                </div>

                <div
                  className="dax-preamble"
                  dangerouslySetInnerHTML={{
                    __html: parsedOperationDescription,
                  }}
                />
              </header>
              <Parameters
                headerParameters={operation.headerParameters}
                pathParameters={operation.pathParameters}
                queryParameters={operation.queryParameters}
                formDataParameters={operation.formDataParameters}
                cleanedRequestBody={operation.cleanedRequestBody}
                cleanedResponse={operation.cleanedResponse}
                samples={operation.samples}
                x_publicSDKSamples={operation.x_publicSDKSamples}
                opAnchor={opAnchor}
              />
              <div className="dax-sample dax-sample-codeblock">
                {publicSDKBlock}

                {operation.samples.map((sample, index) => {
                  if (sample.request) {
                    return (
                      <div key={index}>
                        <div className="dax-title-section">
                          <h4 className="dax-sample-heading">Sample Request</h4>
                          <div className="dax-copy-button">
                            <CopyButton
                              onClick={() =>
                                handleCopyClipboard(sample.request)
                              }
                            >
                              {isCopied ? (
                                <SuccessCheckIcon />
                              ) : (
                                <CopyPasteIcon />
                              )}
                            </CopyButton>
                          </div>
                        </div>

                        <pre className="language-bash dx-pre-hljs apiReference-response">
                          <code>{getCodePieces(sample.request)}</code>
                        </pre>
                      </div>
                    )
                  }
                })}
              </div>
            </div>

            <Responses
              samples={operation.samples}
              parameters={operation.parameters}
              cleanedResponse={operation.cleanedResponse}
              opAnchor={opAnchor}
              preamble={operation.responseDescription}
            />
          </div>
        )
      })}
    </>
  )
}
